import { Flex } from 'antd'
import { ChevronDown } from 'assets/svg'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import NoRecordsComponent from 'core/no-records/no-records-container'
import DateUtils from 'core/utils/date-utils'
import React, { useContext } from 'react'
import useFrequenciesFilter from '../../../context/hook'
import { checkIsEntryHealthy } from '../../helper'
import dvbcMapper from '../../redux/mapper'
import { DVBCHistory, FrequencyLimitsType } from '../../redux/types'
import DVBCTable from '../DVBCTable'

type HistoryEntryProps = {
  index: number
  accordionActiveIndex: number
  setAccordionActiveIndex: React.Dispatch<React.SetStateAction<number>>
  setChildAccordionActiveIndex: React.Dispatch<React.SetStateAction<number>>
  handleActiveAccordion: (clickedAccordionIndex: number, currentActiveIndex: number, setCurrentActiveIndex: React.Dispatch<React.SetStateAction<number>>, setChildAccordionActiveIndex: React.Dispatch<React.SetStateAction<number>>) => void
  frequencyLimits: FrequencyLimitsType
  historyEntry: DVBCHistory
}

export default function HistoryEntry({
  index,
  accordionActiveIndex,
  setAccordionActiveIndex,
  setChildAccordionActiveIndex,
  handleActiveAccordion,
  frequencyLimits,
  historyEntry,
}: HistoryEntryProps) {
  const t = useContext(I18nContext)
  const { filter } = useFrequenciesFilter()
  const isHealthy = checkIsEntryHealthy(historyEntry, filter, frequencyLimits)

  return (
    <li
      className={`accordion-item ${accordionActiveIndex !== index ? 'accordion-item-collapsed' : ''}`}
      key={index}
    >
      <button
        className="accordion-heading"
        onClick={() => handleActiveAccordion(index, accordionActiveIndex, setAccordionActiveIndex, setChildAccordionActiveIndex)}
      >
        <span className="chevron">
          <Flex align='center'>
            <span className={`chevron-status ${isHealthy ? `is-healthy` : `is-unhealthy`}`}/>
            <span className="chevron-text">
              <b>
                {t('rf_tuning.dvbc_history.last_available_data')}:&nbsp;
                {DateUtils.formatDate(historyEntry.lastEventTs)}&nbsp;|&nbsp;
              </b>
              <b>
                {t('rf_tuning.dvbc_history.last_data_modified')}:&nbsp;
                {DateUtils.formatDate(historyEntry.changeEventTs)}&nbsp;|&nbsp;
              </b>
              <b>
                {t('rf_tuning.dvbc_history.count')}:&nbsp;
                {historyEntry.count}
              </b>
            </span>
          </Flex>
          <span className="chevron-container accordion-chevron">
            <ChevronDown className="icon icon-svg" />
          </span>
        </span>
      </button>
      <div className="accordion-content">
        {historyEntry.dvbc ? <DVBCTable dvbc={dvbcMapper(historyEntry.dvbc)} frequencyLimits={frequencyLimits} /> : <NoRecordsComponent />}
      </div>
    </li>
  )
}
